enum DossierTaskType {
	Delivery = "Delivery",
	Installation = "Installation",
	Service = "Service"
}

export default DossierTaskType;